import React from 'react'
import { ControlButton, Controls } from '@xyflow/react'

import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { useAutoLayout } from './hooks/useAutoLayout'

export const AutoLayoutControls: React.FC = () => {
  const { applyConditionalAwareLayout } = useAutoLayout()

  return (
    <div className='absolute bottom-2 right-16 z-10 flex flex-col gap-2'>
      <Controls className='bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 shadow-lg rounded-lg text-gray-900 dark:text-gray-100'>
        <ControlButton onClick={() => applyConditionalAwareLayout()}>
          <MaterialIcon size={14} icon='auto_fix_high' />
        </ControlButton>
      </Controls>
    </div>
  )
}
